<ng-template #Modal let-data let-ref="dialogRef">
  <nb-card class="staffInfoTemplate">
    <nb-card-header>
      {{ 'common_select_store' | translate }}
    </nb-card-header>
    <nb-card-body>
      <div class="mt-3">
        <table class="table table-bordered table-striped">
          <thead>
            <tr>
              <th>{{ 'common_store_name' | translate }}</th>
              <th>{{ 'common_enable' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let e of mainDataList">
              <tr>
                <td>{{ e.content }}</td>
                <td>
                  <nb-toggle status="info" [(checked)]="e.isChecked">
                  </nb-toggle>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </nb-card-body>
    <nb-card-footer>
      <button nbButton (click)="onSave();">{{ 'common_confirm' | translate }}</button>
      <button nbButton (click)="ref.close()">{{ 'common_cancel' | translate }}</button>
    </nb-card-footer>
  </nb-card>
</ng-template>
